<div class="skeleton-main">
    <div class="squire skeleton h50"></div>
    <div class="squire skeleton h50"></div>
    <div class="squire skeleton h50"></div>
    <div class="squire skeleton h50"></div>
    <div class="squire skeleton h50"></div>
</div>
